import { CollectDataStepType } from './enums'

/**
 * Admin-facing display name per collect-data step type. Shared by the flow editor and the
 * onboarding-templates list, so it lives beside the enum rather than inside either page.
 */
export const STEP_LABELS: Record<string, string> = {
  [CollectDataStepType.BGC]: 'Background Check',
  [CollectDataStepType.EIN]: 'Business Entity',
  [CollectDataStepType.DriverLicense]: 'Driver License',
  [CollectDataStepType.Form]: 'Form',
  [CollectDataStepType.InsuranceDeclaration]: 'Insurance Amt. Declaration',
  [CollectDataStepType.InsuranceCoverage]: 'Insurance',
  [CollectDataStepType.InsuranceBeneficiary]: 'Insurance Beneficiary',
  [CollectDataStepType.MVR]: 'MVR Upload',
  [CollectDataStepType.VehicleInsurance]: 'Vehicle & Insurance',
  [CollectDataStepType.VehicleRegistration]: 'Vehicle Registration',
  [CollectDataStepType.SignContract]: 'Sign Contract',
  [CollectDataStepType.LMSTraining]: 'LMS Training',
  [CollectDataStepType.MCNumber]: 'MC Number',
  [CollectDataStepType.DOTNumber]: 'DOT Number',
  [CollectDataStepType.PIICollection]: 'SSN & Address',
  [CollectDataStepType.PaymentMethod]: 'Payment Method',
}

/** Falls back to a title-cased version of the raw type for a type added on the backend first. */
export function stepLabel(type: string): string {
  return (
    STEP_LABELS[type] ??
    type.replace(/_/g, ' ').replace(/\b\w/g, (character) => {
      return character.toUpperCase()
    })
  )
}
